import React from "react";
import think from "../assets/GettyImages-948000872.jpg";
import arrowup from "../assets/arrowblue.png";

const JustAboutYou = () => {
  return (
    <div> 
      <h2 className="text-xl font-bold text-gray-800 mb-6">
        {"Remember… This Isn’t Just About You. "} 
      </h2> 
      <div className="relative w-full mb-6">
        <img 
          src={think} 
          alt="Lung diagram with surrounding bacterial images"
          className="w-full border border-gray-100 rounded-3xl" 
          draggable="false" 
        />
      </div> 
      <div className="space-y-4 text-[#303030]"> 
        <p> 
          { 
            "It’s about the peace of mind for loved ones—those who worry with every breath that seems like a struggle."
          }  
        </p> 
        <p> 
          { 
            "It’s about children or grandkids who look forward to fun, active weekends, only to have plans cut short by coughing or wheezing."
          } 
        </p> 
        <p> 
          {  
            "It’s about the partner who feels the weight of solitude when chronic respiratory issues take over."
          }  
        </p> 

        <p>
          <span className="bg-[#ffbf00] font-bold">  
            {" You owe it to yourself—and them—to try “Breathe. "}  
          </span>
        </p>
         
        <div className="bg-[#e2f4f9] p-4"> 
          <div className="flex items-center gap-3 mb-4 last:mb-0"> 
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={arrowup}  
                  alt="" 
                  className="w-10 h-10"  
                  draggable="false"  
                />
              </div> 
            </div> 
            <p className="text-gray-800 font-bold">  
              {"The path to renewal is within reach. "} 
            </p> 
          </div>  
          <div className="flex items-center gap-3 mb-4 last:mb-0">
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={arrowup} 
                  alt="" 
                  className="w-10 h-10"
                  draggable="false"
                />
              </div>  
            </div>
            <p className="text-gray-800 font-bold">
              {"Relief once hoped for can finally be rediscovered. "} 
            </p>
          </div>
          <div className="flex items-center gap-3 mb-4 last:mb-0"> 
            <div className="flex-shrink-0"> 
              <div className="flex-shrink-0"> 
                <img 
                  src={arrowup} 
                  alt="" 
                  className="w-10 h-10" 
                  draggable="false" 
                /> 
              </div> 
            </div> 
            <p className="text-gray-800 font-bold">  
              {"A more vibrant life is ready to be reclaimed. "}  
            </p>  
          </div> 
        </div> 
        <p>  
          {"Many have done it already—and so can you—with the help of "} 
          <span className="font-bold ">{" “Breathe,”  "}</span>  relief can be achieved.
        </p> 
        <p className="font-bold">{"Daily Use, Maximum Results"}</p> 
        <p>
          {" Just drop "} 
          <span className="font-bold bg-[#ffbf00]"> 
            {"2–3 times a day"} 
          </span>{" "} 
          { 
            "help loosen stubborn mucus and support healthier lungs over time. " 
          } 
        </p>
        <p>   
          {"Unlike synthetic medications that create dependence,"}{" "} 
          <span className="font-bold">{"“Breathe”"}</span> {"combines "}{" "}  
          <span className="font-bold">{"Mullein"}</span>{" "} 
          {" (the ‘lost herb’) with vital vitamins."}   
        </p>
        <p>
          {"antioxidants, and amino acids"}{" "}  
          <span className="font-bold bg-[#ffbf00]">{"100% natural"}</span> 
          {" and designed to work gently with your body."}
        </p>
        <p className="bg-[#ffbf00]"> 
          { 
            "Imagine waking up and taking that first deep, lung-clearing breath without coughing or struggling!"  
          }
        </p>  
        <p className="font-bold">{"Ready to Feel the Difference?"}</p> 
        <p>
          <span className="font-bold bg-[#ffbf00]">{" Try Breathe now"}</span>{" "}
          {"because if it doesn’t work as promised, we offer a"}  
          <span className="font-bold">
            {" "}
            {" 60-day money-back guarantee. "}{" "}
          </span>
          {"You don’t pay if it doesn’t work!"}
        </p>
      </div>
    </div>
  );
};

export default JustAboutYou;
